import React from 'react';
import { getCommitteeDocuments, saveCommitteeDocument, deleteCommitteeDocument, checkResponse, dispatchLoader, dispatchError} from '../../../../../../Redux/Actions/Admin/ManageCommitteeAction';
import { connect } from 'react-redux';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import { Alert } from 'reactstrap';
import { withRouter } from 'react-router';
import ReactFileReader from 'react-file-reader';
import {Table} from 'reactstrap';
import { Input } from '@progress/kendo-react-inputs';
import { provideIntlService } from '@progress/kendo-react-intl';
import '../../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/AuthorizedMembers.scss';
import { auth } from '../../../../../../services/auth.service';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../api-config';

class AddDocumentForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
            committeeEdit: this.props.dataItem || "",
            uploadTitle: 'File Upload',
            documentEdit:{
                committeeDocumentId: 0,
                documentName: "",
                fileUploadViewModel: null,
                committeeId: 0,
            }
		};
	}

	componentDidMount() {
        console.log(this.state.committeeEdit, "state in committee documents")
       this.props.getCommitteeDocuments(this.state.committeeEdit.CommitteeId);
   
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.committeeDocuments !== this.props.committeeDocuments) {
            this.setState({
                ...this.props.committeeDocuments
            })
        }
    }
    handleSubmit = (event) => {
        event.preventDefault();

        const edited = this.state.documentEdit;
        edited.committeeId = this.state.committeeEdit.CommitteeId;

        var url = `${ROOT_API_URL}/ManageCommittee/SaveCommitteeDocument`;
        const options = { method: 'POST', headers: auth.authHeader() };

        this.props.dispatchLoader();
        axios.post(url, edited, options).then((response) => {
            this.props.checkResponse(response);           
            this.setState({
                uploadTitle: 'File Upload',
                documentEdit: {
                    committeeDocumentId: 0,
                    documentName: "",
                    fileUploadViewModel: null,
                    committeeId: 0,
                }
            })
        })
            .catch((response) => {
            this.props.dispatchError();
        });
    };
    
    onDialogInputChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.documentEdit;
		edited[name] = value;
		this.setState({
            documentEdit: edited
		});
	};
    handleFiles = (event) => {
        this.setState({
            uploadTitle: event.fileList[0].name
        });

        console.log("files", event.fileList[0]);
        const edited = this.state.documentEdit;
        edited.fileUploadViewModel = event?{
            name: event.fileList[0].name,
            source: event.base64,
            extension: event.fileList[0].type
        }:null;
    }
    DeleteDocument = (event) => {
        event.isActive = false;
        this.props.deleteCommitteeDocument(event);
    };
	render() {
		if (this.props.getting)
			return (
				<div>
					<IsLoading />
				</div>
			);
		return (
			<React.Fragment>
			{this.props.common.visible ? (
				<Alert
					color={this.props.common.color}
					isOpen={this.props.common.visible}
                    style={{ position: 'fixed', width: '100%', maxHeight: '50px', zIndex: '1', top: '110px' }}
				>
					{this.props.common.message}
				</Alert>
            ) : null}
            <form className="user-form membership-form" onSubmit={this.handleSubmit}>
                        <div className="form-group col-md-12">
                            <h2 className="callout">Enter <span className="highlight">Committee Documents</span></h2>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-6 documentInfo">
                                <label htmlFor="documentName">Document Name</label>
                                <Input
                                    required={true}
                                    type="text"
                                    name="documentName"
                                    id="documentName"
                                    value={this.state.documentEdit.documentName}
                                    onChange={this.onDialogInputChange}
						        ></Input>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-6 documentInfo">
                                <label>{this.state.uploadTitle}</label>
                            <ReactFileReader fileTypes={["."]} base64={true} multipleFiles={false} handleFiles={this.handleFiles} >
                                    <button className="btnPrimary" onClick={(event)=> {event.preventDefault();}}>Upload</button>
                                </ReactFileReader>
                            </div>
                        </div>
                        <div className="form-group col-md-12">
                            <button type="submit" className="admin-k-button">
                                <i className="fas fa-save"></i>
                                <span>SAVE</span>
                            </button>
                        </div>
                    </form>
		      
                    {/* <div className="member-form form-group col-md-12 col-lg-12">
                        <h1 className="pt-3 pb-3">Existing Documents</h1>
                                <Table hover className="edit-account-form card">
                                    <thead>
                                        <tr>
                                            <th>Document Name </th>
                                            <th>Created Date</th>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.committeeDocuments.length >0?this.props.committeeDocuments.map((item,i) => 
                                        <tr>
                                        <td>{item.documentName}</td>
                                        <td>{provideIntlService(this).formatDate(new Date(item.createDate), 'MM/d/y')}</td>
                                        <td><a href={item.fileUploadViewModel.source} download={item.fileUploadViewModel.name + item.fileUploadViewModel.extension}>View Document</a></td>
                                        <td><button className="admin-k-button" onClick={() => this.DeleteDocument(item)}>
                                                <span>DELETE</span>
                                            </button>
                                        </td>
                                        </tr>
                                    ):""}
                                    </tbody>
                                </Table>
                    </div> */}
                    <div className="account-tab-content">
					<div>
						<div>
							<h1 className="pt-3 pb-3">Committee Documents</h1>
						</div>
					</div>
				</div>
				<div className="account-tab-content authorized-members">
					<div className="table-responsive">
							<Table hover className="edit-account-form card">
								<thead>
									<tr>
										<th>Document Name</th>
										<th>Created Date</th>
										<th></th>
                                        <th></th>
									</tr>
								</thead>
								<tbody>
								{this.props.committeeDocuments.length >0?this.props.committeeDocuments.map((item,i) => 
									<tr>
										<td>{item.documentName}</td>
                                      	<td>{provideIntlService(this).formatDate(new Date(item.createDate), 'MM/d/y')}</td>
                                      	<td><a href={item.fileUploadViewModel.source} download={item.fileUploadViewModel.name + item.fileUploadViewModel.extension } className="downloadBtn" >Download</a></td>
                                          <td><button className="admin-k-button" onClick={() => this.DeleteDocument(item)}>
                                                <span>DELETE</span>
                                            </button>
                                        </td>
                                    </tr>
								):""}
								</tbody>
							</Table>
					</div>
				</div>
				<div className="footer col-md-12 adjustFooterpadding">
					<div className="form-group">
						<button className="admin-k-button" onClick={this.props.cancel}>
							<span>CANCEL</span>
						</button>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {
		committeeDocuments: state.committee.committeeDocuments,
		common: state.common
	};
}

export default withRouter(connect(mapStateToProps, {
    getCommitteeDocuments, saveCommitteeDocument, deleteCommitteeDocument, checkResponse, dispatchLoader, dispatchError
})(AddDocumentForm));
